// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__yaNpX","vLegacy":"SelectSecondary_vLegacy__1ne3m","error":"SelectSecondary_error__1LKkc","disabled":"SelectSecondary_disabled__38D2N"};